@if ((isAiChat$ | async) === true || (isTutorialChat$ | async) === true) {
  @if (!(isCustomChat$ | async)) {
    <app-ai-relationships-bar></app-ai-relationships-bar>
  }
}
@if (isSuggestionsVisible$ | async) {
  <div class="ai-suggestions">
    <div class="title">Suggestions:</div>

    <div class="suggestions-list">
      @for (answer of aiAnswersSuggestions$ | async; track $index) {
        <div class="ai-suggestion-wrapper" appDragScroll>
          <button (click)="aiSuggestionClick(answer)" class="ai-suggestion-btn">
            {{ answer }}
          </button>
        </div>
      }
    </div>
  </div>
}
<footer
  *ngIf="
    (chatState$ | async) !== 'offline' && (chatState$ | async) !== 'finished'
  "
>
  <app-new-photo-notification></app-new-photo-notification>
  @for (answer of answers$ | async; track answer.id; let index = $index) {
    @if (answer.type === "input") {
      @if ((isAiChat$ | async) && !answer.isNicknameInput) {
        <form
          (submit)="submitInput(answer, $event)"
          class="answer-message-button"
        >
          @if (isPhotoRequest) {
            <button
              type="button"
              class="selected-mode-btn"
              (click)="cancelPhotoRequest()"
            >
              <svg
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.71429 0C0.76875 0 0 0.76875 0 1.71429V10.2857C0 11.2312 0.76875 12 1.71429 12H10.2857C11.2312 12 12 11.2312 12 10.2857V1.71429C12 0.76875 11.2312 0 10.2857 0H1.71429ZM3.42857 2.14286C3.76956 2.14286 4.09659 2.27832 4.33771 2.51943C4.57883 2.76055 4.71429 3.08758 4.71429 3.42857C4.71429 3.76956 4.57883 4.09659 4.33771 4.33771C4.09659 4.57883 3.76956 4.71429 3.42857 4.71429C3.08758 4.71429 2.76055 4.57883 2.51943 4.33771C2.27832 4.09659 2.14286 3.76956 2.14286 3.42857C2.14286 3.08758 2.27832 2.76055 2.51943 2.51943C2.76055 2.27832 3.08758 2.14286 3.42857 2.14286ZM7.28571 5.14286C7.51071 5.14286 7.71696 5.26071 7.83482 5.45089L10.192 9.30804C10.3125 9.50625 10.3179 9.75536 10.2054 9.95893C10.0929 10.1625 9.87589 10.2857 9.64286 10.2857H2.35714C2.11875 10.2857 1.89643 10.1518 1.78661 9.94018C1.67679 9.72857 1.69286 9.47143 1.82946 9.27589L3.32946 7.13304C3.45 6.96161 3.64554 6.85982 3.85714 6.85982C4.06875 6.85982 4.26429 6.96161 4.38482 7.13304L5.09196 8.14554L6.73661 5.45357C6.85446 5.26339 7.06071 5.14554 7.28571 5.14554V5.14286Z"
                  fill="currentColor"
                />
              </svg>
              <svg
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.99486 7.00636C6.60433 7.39689 6.60433 8.03005 6.99486 8.42058L10.58 12.0057L6.99486 15.5909C6.60433 15.9814 6.60433 16.6146 6.99486 17.0051C7.38538 17.3956 8.01855 17.3956 8.40907 17.0051L11.9942 13.4199L15.5794 17.0051C15.9699 17.3956 16.6031 17.3956 16.9936 17.0051C17.3841 16.6146 17.3841 15.9814 16.9936 15.5909L13.4084 12.0057L16.9936 8.42059C17.3841 8.03007 17.3841 7.3969 16.9936 7.00638C16.603 6.61585 15.9699 6.61585 15.5794 7.00638L11.9942 10.5915L8.40907 7.00636C8.01855 6.61584 7.38538 6.61584 6.99486 7.00636Z"
                  fill="currentColor"
                />
              </svg>
            </button>
          }
          <div class="answer-content">
            <div class="textarea-wrapper">
              <div class="size-helper">{{ inputField + " " }}</div>
              <textarea
                #aiInputField
                [(ngModel)]="inputField"
                rows="1"
                name="input"
                [maxlength]="maxMessageLength"
                (keydown.enter)="submitInput(answer, $event)"
                (ngModelChange)="onInputChange($event)"
              ></textarea>

              <div class="placeholder" [class.hidden]="inputField.length">
                @if (answer.isNicknameInput) {
                  {{ "CHATS_PAGE.WRITE_YOUR_NICKNAME" | translate }}
                } @else {
                  Write a message
                }
                <img src="/assets/img/chat-page/input-icon.svg" alt="" />
              </div>
            </div>
          </div>

          <!-- <div class="vertical-line"></div> -->
          @if (!isPhotoRequest && !isBoy) {
            <div (clickOutside)="closeTagMenu()">
              @if (isTagMenuOpen) {
                <div class="ask-menu">
                  <div class="ask-menu__content">
                    <div class="ask_menu__title">Send me a photo...</div>
                    @for (el of askTags; track $index) {
                      <button
                        type="button"
                        class="ask-menu__btn"
                        (click)="tagClick(el.tag)"
                      >
                        <img [src]="el.img" alt="" />
                        {{ el.text }}
                      </button>
                    }
                  </div>
                </div>
              }

              <button
                type="button"
                class="ask-button"
                (click)="toggleTagMenu()"
              >
                <div class="button-content">
                  <svg
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.71429 0C0.76875 0 0 0.76875 0 1.71429V10.2857C0 11.2312 0.76875 12 1.71429 12H10.2857C11.2312 12 12 11.2312 12 10.2857V1.71429C12 0.76875 11.2312 0 10.2857 0H1.71429ZM3.42857 2.14286C3.76956 2.14286 4.09659 2.27832 4.33771 2.51943C4.57883 2.76055 4.71429 3.08758 4.71429 3.42857C4.71429 3.76956 4.57883 4.09659 4.33771 4.33771C4.09659 4.57883 3.76956 4.71429 3.42857 4.71429C3.08758 4.71429 2.76055 4.57883 2.51943 4.33771C2.27832 4.09659 2.14286 3.76956 2.14286 3.42857C2.14286 3.08758 2.27832 2.76055 2.51943 2.51943C2.76055 2.27832 3.08758 2.14286 3.42857 2.14286ZM7.28571 5.14286C7.51071 5.14286 7.71696 5.26071 7.83482 5.45089L10.192 9.30804C10.3125 9.50625 10.3179 9.75536 10.2054 9.95893C10.0929 10.1625 9.87589 10.2857 9.64286 10.2857H2.35714C2.11875 10.2857 1.89643 10.1518 1.78661 9.94018C1.67679 9.72857 1.69286 9.47143 1.82946 9.27589L3.32946 7.13304C3.45 6.96161 3.64554 6.85982 3.85714 6.85982C4.06875 6.85982 4.26429 6.96161 4.38482 7.13304L5.09196 8.14554L6.73661 5.45357C6.85446 5.26339 7.06071 5.14554 7.28571 5.14554V5.14286Z"
                      fill="currentColor"
                    />
                  </svg>
                  Ask
                  <svg
                    viewBox="0 0 8 6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="arrow"
                    [class.rotated]="isTagMenuOpen"
                  >
                    <path
                      d="M7.82391 0.6912C7.71112 0.568775 7.55817 0.5 7.39869 0.5C7.23921 0.5 7.08626 0.568775 6.97348 0.6912L3.99637 3.92372L1.01926 0.691199C0.905829 0.572244 0.753905 0.506421 0.59621 0.50791C0.438515 0.509397 0.287667 0.578076 0.176157 0.699154C0.0646454 0.820232 0.00139343 0.98402 2.34579e-05 1.15524C-0.00134699 1.32647 0.0592742 1.49142 0.16883 1.61459L3.57115 5.3088C3.68394 5.43123 3.83689 5.5 3.99637 5.5C4.15585 5.5 4.3088 5.43123 4.42158 5.3088L7.82391 1.61459C7.93666 1.49213 8 1.32606 8 1.15289C8 0.979733 7.93666 0.813662 7.82391 0.6912Z"
                      fill="currentColor"
                    />
                  </svg>
                </div>
              </button>
            </div>
          }

          <button type="submit" class="answer-send-area btn-with-cost">
            @if (answer.costInGems && false) {
              <div class="message-cost">
                <img src="/assets/img/icon/tokens.png" alt="" />
                {{ answer.costInGems }}
              </div>
            }
            <img
              src="/assets/img/chat-page/send-btn.svg"
              alt=""
              class="send-icon"
            />
          </button>
        </form>
      } @else {
        <form
          (submit)="submitInput(answer, $event)"
          class="answer-message-button"
        >
          @if (!answer.isNicknameInput) {
            <!-- <span class="characters-count">
              {{ inputField.length }}/{{ maxMessageLength }}
            </span> -->
          }

          <div class="answer-content">
            <div class="textarea-wrapper">
              <div class="size-helper">{{ inputField + " " }}</div>
              <textarea
                [(ngModel)]="inputField"
                rows="1"
                name="input"
                [maxlength]="maxMessageLength"
                (keydown.enter)="submitInput(answer, $event)"
              ></textarea>

              <div class="placeholder" [class.hidden]="inputField.length">
                @if (answer.isNicknameInput) {
                  {{ "CHATS_PAGE.WRITE_YOUR_NICKNAME" | translate }}
                } @else {
                  Write a message
                }
                <img src="/assets/img/chat-page/input-icon.svg" alt="" />
              </div>
            </div>
          </div>
          <div class="vertical-line"></div>
          <button type="submit" class="answer-send-area btn-with-cost">
            @if (answer.costInGems && false) {
              <div class="message-cost">
                <img src="/assets/img/icon/tokens.png" alt="" />
                {{ answer.costInGems }}
              </div>
            }
            <img
              src="/assets/img/chat-page/send-btn.svg"
              alt=""
              class="send-icon"
            />
          </button>
        </form>
      }
    } @else {
      <div
        (click)="sendAnswer(answer)"
        class="answer-message-button predefined-answer"
      >
        <div class="answer-content">
          <span
            [innerHTML]="
              (answer.localizedMessageText | parseEmoji) ||
              (answer.messageText | parseEmoji)
            "
            class="message-text"
          ></span>
        </div>

        <div class="vertical-line"></div>

        <div class="answer-send-area">
          @if (answer.costInGems) {
            <app-button class="price-btn">
              <div class="btn-content">
                <img src="/assets/img/icon/tokens.png" alt="" />
                {{ answer.costInGems }}
              </div>
            </app-button>
          } @else {
            <img
              src="/assets/img/chat-page/send-btn.svg"
              alt=""
              class="send-icon"
            />
          }
        </div>
      </div>
    }
  } @empty {
    <div (click)="clickEmpty()" class="answer-message-button empty-message">
      <div class="answer-content"></div>
      <div class="vertical-line"></div>
      <div class="answer-send-area">
        <img
          src="/assets/img/chat-page/send-btn.svg"
          alt=""
          class="send-icon"
        />
      </div>
    </div>
  }
</footer>
